import { set_ui_settings } from 'console/redux/settings-actions';
import { boundsToCenterAndZoom } from 'shared/map/lib/utils';
import { selectDevice } from 'entities/device/lib';
import { calcGeozoneGeoBounds, findGeozoneFromId, } from 'console/entities/map.geozone/utils/utils';
import { setMapCenterAndZoom, showHighlightRings } from 'shared/map/model/slice';
export const focusDeviceOnMap = (device_id = null) => (dispatch, getState) => {
    const dev = selectDevice(getState(), device_id);
    const last = dev && dev.last_gps?.[0];
    if (dev != null && last != null) {
        dispatch(showHighlightRings({
            loc: [last.x, last.y],
            color: dev.color || '#c4443b',
            device_id,
        }));
    }
};
export const setMapProviderAndType = (provider, type) => (dispatch, getState) => {
    const prov_config = get_provider_config(getState().map.providers_config, provider);
    if (prov_config && prov_config.types[type] != null) {
        dispatch(set_ui_settings({ map: { provider, type } }));
    }
    else {
        dispatch(set_ui_settings({ map: { provider, type: 'street' } }));
    }
};
export const setMapUiSetting = (data) => (dispatch) => {
    dispatch(set_ui_settings({ map: data }));
};
export function get_provider_config(providers_config, provider_id) {
    for (const prov_config of providers_config.providers) {
        if (prov_config.id === provider_id) {
            return prov_config;
        }
    }
    return null;
}
export const zoomOnGeozone = (geozone_id, device_id = null) => (dispatch, getState) => {
    const geozones = getState().geozones;
    //Получили ид и нашли геозону
    const geozone = findGeozoneFromId(geozones, geozone_id);
    if (geozone != null) {
        //Отцентровались на этой геозоне
        const bounds = calcGeozoneGeoBounds(geozone.geojson.geometry.type, geozone.geojson.geometry.coordinates, geozone.geojson.properties ? geozone.geojson.properties.radius : null);
        const state = getState().map.items[device_id ?? -1];
        const result = boundsToCenterAndZoom(bounds, state.size);
        if (result != null) {
            const [center, zoom] = result;
            dispatch(setMapCenterAndZoom({ center, zoom: Math.min(17, zoom), device_id }));
        }
    }
};
